const productEducationFields = {
  fabricOrBenefits: "fabricOrBenefits",
  fitOrHowToUse: "fitOrIngredients",
  featuresOrIngredients: "featuresOrHowToUse",
};

// NOTE: this is _functionally redundant to `selectProductEducation`
// in `packages/ecom-pdp/src/selectors/selected-item.js`
const productEductionTransform = (colorAttributes = []) => {
  return Object.entries(colorAttributes?.[0] ?? {})?.reduce((prev, [k, v]) => {
    if (Object.keys(productEducationFields).includes(k) && v?.title) {
      return [
        ...prev,
        {
          iconId: v.iconId,
          title: v.title,
          media: v?.sections?.[0]?.media || [],
          attributes: v?.sections?.[0]?.attributes || [],
          id: productEducationFields[k],
        },
      ];
    }
    return prev;
  }, []);
};

export default productEductionTransform;
